import { TAB } from '@angular/cdk/keycodes';
import {
  forwardRef,
  Component,
  ElementRef,
  EventEmitter,
  HostBinding,
  Input,
  Output,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';

import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { toBoolean } from '../util/convert';

@Component({
  selector     : 'nz-input-number',
  encapsulation: ViewEncapsulation.None,
  template     : `
    <div class="ant-input-number-handler-wrap"
      (mouseover)="_mouseInside = true"
      (mouseout)="_mouseInside = false">
      <a class="ant-input-number-handler ant-input-number-handler-up"
        [ngClass]="{'ant-input-number-handler-up-disabled':_disabledUp}"
        (click)="_numberUp($event)">
        <span
          class="ant-input-number-handler-up-inner"
          (click)="$event.preventDefault();"></span>
      </a>
      <a
        class="ant-input-number-handler ant-input-number-handler-down"
        [ngClass]="{'ant-input-number-handler-down-disabled':_disabledDown}"
        (click)="_numberDown($event)">
        <span
          class="ant-input-number-handler-down-inner"
          (click)="$event.preventDefault();">
        </span>
      </a>
    </div>
    <div
      class="ant-input-number-input-wrap">
      <input class="ant-input-number-input"
        #inputNumber
        [placeholder]="nzPlaceHolder"
        [disabled]="nzDisabled"
        [(ngModel)]="_displayValue"
        (blur)="_emitBlur($event)"
        (focus)="_emitFocus($event)"
        (keydown)="_emitKeyDown($event)"
        [attr.min]="nzMin"
        [attr.max]="nzMax"
        [attr.step]="_step"
        autocomplete="off">
    </div>`,
  providers    : [
    {
      provide    : NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NzInputNumberComponent),
      multi      : true
    }
  ],
  styles: [
    `/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable declaration-bang-space-before */
/* stylelint-disable declaration-bang-space-before */
.ant-input-number {
  position: relative;
  padding: 4px 7px;
  width: 100%;
  cursor: text;
  line-height: 1.5;
  color: #666;
  background-color: #fff;
  background-image: none;
  transition: all .3s;
  margin: 0;
  padding: 0;
  font-size: 14px;
  height: 30px;
  display: inline-block;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  width: 80px;
}
.ant-input-number::-moz-placeholder {
  color: rgba(0, 0, 0, 0.25);
  opacity: 1;
}
.ant-input-number:-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.25);
}
.ant-input-number::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.25);
}
.ant-input-number:hover {
  border-color: #3dc9be;
}
.ant-input-number:focus {
  border-color: #3dc9be;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(0, 184, 169, 0.2);
}
.ant-input-number-disabled {
  background-color: #f7f7f7;
  opacity: 1;
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.25);
}
.ant-input-number-disabled:hover {
  border-color: #e2e2e2;
}
textarea.ant-input-number {
  max-width: 100%;
  height: auto;
  vertical-align: bottom;
  resize: none;
}
.ant-input-number-lg {
  padding: 6px 7px;
  height: 34px;
}
.ant-input-number-sm {
  padding: 1px 7px;
  height: 28px;
}
.ant-input-number-handler {
  text-align: center;
  line-height: 0;
  height: 50%;
  overflow: hidden;
  color: rgba(0, 0, 0, 0.43);
  position: relative;
  transition: all 0.1s linear;
  display: block;
  width: 100%;
  font-weight: bold;
}
.ant-input-number-handler:active {
  background: #f4f4f4;
}
.ant-input-number-handler:hover .ant-input-number-handler-up-inner,
.ant-input-number-handler:hover .ant-input-number-handler-down-inner {
  color: #3dc9be;
}
.ant-input-number-handler-up-inner,
.ant-input-number-handler-down-inner {
  font-style: normal;
  vertical-align: baseline;
  text-align: center;
  text-transform: none;
  line-height: 1;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: 12px;
  user-select: none;
  position: absolute;
  width: 12px;
  height: 12px;
  transition: all 0.1s linear;
  display: inline-block;
  font-size: 14px;
  font-size: 7px \9;
  transform: scale(0.58333333) rotate(0deg);
  /* IE6-IE8 */
  -ms-filter: "progid:DXImageTransform.Microsoft.Matrix(sizingMethod='auto expand', M11=1, M12=0, M21=0, M22=1)";
  zoom: 1;
  right: 4px;
  color: rgba(0, 0, 0, 0.43);
}
.ant-input-number-handler-up-inner:before,
.ant-input-number-handler-down-inner:before {
  display: block;
  font-family: "anticon" !important;
}
:root .ant-input-number-handler-up-inner,
:root .ant-input-number-handler-down-inner {
  filter: none;
}
:root .ant-input-number-handler-up-inner,
:root .ant-input-number-handler-down-inner {
  font-size: 14px;
}
.ant-input-number:hover {
  border-color: #3dc9be;
}
.ant-input-number-focused {
  border-color: #3dc9be;
  outline: 0;
  box-shadow: 0 0 0 2px rgba(0, 184, 169, 0.2);
}
.ant-input-number-disabled {
  background-color: #f7f7f7;
  opacity: 1;
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.25);
}
.ant-input-number-disabled:hover {
  border-color: #e2e2e2;
}
.ant-input-number-input {
  width: 100%;
  text-align: left;
  outline: 0;
  -moz-appearance: textfield;
  height: 28px;
  transition: all 0.3s linear;
  color: #666;
  background-color: #fff;
  border: 0;
  border-radius: 4px;
  padding: 0 7px;
  display: block;
}
.ant-input-number-input::-moz-placeholder {
  color: rgba(0, 0, 0, 0.25);
  opacity: 1;
}
.ant-input-number-input:-ms-input-placeholder {
  color: rgba(0, 0, 0, 0.25);
}
.ant-input-number-input::-webkit-input-placeholder {
  color: rgba(0, 0, 0, 0.25);
}
.ant-input-number-input[disabled] {
  background-color: #f7f7f7;
  opacity: 1;
  cursor: not-allowed;
  color: rgba(0, 0, 0, 0.25);
}
.ant-input-number-input[disabled]:hover {
  border-color: #e2e2e2;
}
.ant-input-number-lg {
  padding: 0;
}
.ant-input-number-lg input {
  height: 32px;
}
.ant-input-number-sm {
  padding: 0;
}
.ant-input-number-sm input {
  height: 26px;
}
.ant-input-number-handler-wrap {
  border-left: 1px solid #d9d9d9;
  width: 22px;
  height: 100%;
  background: #fff;
  position: absolute;
  top: 0;
  right: 0;
  opacity: 0;
  border-radius: 0 4px 4px 0;
  transition: opacity 0.24s linear 0.1s;
  z-index: 2;
}
.ant-input-number-handler-wrap:hover .ant-input-number-handler {
  height: 40%;
}
.ant-input-number:hover .ant-input-number-handler-wrap {
  opacity: 1;
}
.ant-input-number-handler-up {
  cursor: pointer;
}
.ant-input-number-handler-up-inner {
  top: 50%;
  margin-top: -6px;
}
.ant-input-number-handler-up-inner:before {
  text-align: center;
  content: "\\e61e";
}
.ant-input-number-handler-up:hover {
  height: 60% !important;
}
.ant-input-number-handler-down {
  border-top: 1px solid #d9d9d9;
  top: -1px;
  cursor: pointer;
}
.ant-input-number-handler-down-inner {
  top: 50%;
  margin-top: -6px;
}
.ant-input-number-handler-down-inner:before {
  text-align: center;
  content: "\\e61d";
}
.ant-input-number-handler-down:hover {
  height: 60% !important;
}
.ant-input-number-handler-down-disabled .ant-input-number-handler-down-inner,
.ant-input-number-handler-up-disabled .ant-input-number-handler-down-inner,
.ant-input-number-disabled .ant-input-number-handler-down-inner,
.ant-input-number-handler-down-disabled .ant-input-number-handler-up-inner,
.ant-input-number-handler-up-disabled .ant-input-number-handler-up-inner,
.ant-input-number-disabled .ant-input-number-handler-up-inner {
  opacity: 0.72;
  color: #ccc !important;
  cursor: not-allowed;
}
.ant-input-number-disabled .ant-input-number-input {
  opacity: 0.72;
  cursor: not-allowed;
  background-color: #f7f7f7;
}
.ant-input-number-disabled .ant-input-number-handler-wrap {
  display: none;
}
.ant-input-number-disabled .ant-input-number-handler {
  opacity: 0.72;
  color: #ccc !important;
  cursor: not-allowed;
}
`
  ]
})
export class NzInputNumberComponent implements ControlValueAccessor {
  private _disabled = false;
  _el: HTMLElement;
  _value: number;
  _size = 'default';
  _prefixCls = 'ant-input-number';
  _step = 1;
  _precisionStep = 0;
  _precisionFactor = 1;
  _displayValue;
  _disabledUp = false;
  _disabledDown = false;
  _focused = false;
  _mouseInside = false;
  // ngModel Access
  onChange: (value: number) => void = () => null;
  onTouched: () => void = () => null;
  @ViewChild('inputNumber') _inputNumber: ElementRef;

  @Input() nzPlaceHolder = '';
  @Input() nzMin: number = -Infinity;
  @Input() nzMax: number = Infinity;
  @Input() nzFormatter = (value) => value;
  @Input() nzParser = (value) => value;

  @Input()
  @HostBinding('class.ant-input-number-disabled')
  set nzDisabled(value: boolean) {
    this._disabled = toBoolean(value);
  }

  get nzDisabled(): boolean {
    return this._disabled;
  }

  @Input()
  set nzSize(value: string) {
    this._renderer.removeClass(this._el, `${this._prefixCls}-${this._size}`);
    this._size = { large: 'lg', small: 'sm' }[ value ];
    this._renderer.addClass(this._el, `${this._prefixCls}-${this._size}`);
  }

  get nzSize(): string {
    return this._size;
  }

  @Input()
  set nzStep(value: number) {
    this._step = value;
    const stepString = value.toString();
    if (stepString.indexOf('e-') >= 0) {
      this._precisionStep = parseInt(stepString.slice(stepString.indexOf('e-')), 10);
    }
    if (stepString.indexOf('.') >= 0) {
      this._precisionStep = stepString.length - stepString.indexOf('.') - 1;
    }
    this._precisionFactor = Math.pow(10, this._precisionStep);
  }

  get nzStep(): number {
    return this._step;
  }

  // TODO: should reconsider the payload
  @Output() nzBlur: EventEmitter<FocusEvent | KeyboardEvent> = new EventEmitter();
  @Output() nzFocus: EventEmitter<FocusEvent> = new EventEmitter();

  _numberUp($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this._inputNumber.nativeElement.focus();
    if (this.nzValue === undefined) {
      this.nzValue = this.nzMin || 0;
    }
    if (!this._disabledUp) {
      this.nzValue = this.toPrecisionAsStep((this._precisionFactor * this.nzValue + this._precisionFactor * this.nzStep) / this._precisionFactor);
    }
  }

  _numberDown($event: MouseEvent): void {
    $event.preventDefault();
    $event.stopPropagation();
    this._inputNumber.nativeElement.focus();
    if (this.nzValue === undefined) {
      this.nzValue = this.nzMin || 0;
    }
    if (!this._disabledDown) {
      this.nzValue = this.toPrecisionAsStep((this._precisionFactor * this.nzValue - this._precisionFactor * this.nzStep) / this._precisionFactor);
    }
  }

  get nzValue(): number {
    return this._value;
  }

  set nzValue(value: number) {
    this._updateValue(value);
  }

  _emitBlur($event: FocusEvent): void {
    // avoid unnecessary events
    if (this._focused && !this._mouseInside) {
      this._checkValue();
      this._focused = false;
      this.nzBlur.emit($event);
    }
    this.onTouched();
  }

  _emitFocus($event: FocusEvent): void {
    // avoid unnecessary events
    if (!this._focused) {
      this._focused = true;
      this.nzFocus.emit($event);
    }
  }

  _emitKeyDown($event: KeyboardEvent): void {
    if ($event.keyCode === TAB && this._focused) {
      this._checkValue();
      this._focused = false;
      this.nzBlur.emit($event);
    }
  }

  _checkValue(): void {
    const numberValue = +this.nzParser(this._displayValue);
    if (this._isNumber(numberValue)) {
      this.nzValue = numberValue;
    } else {
      this._displayValue = this.nzFormatter(this._value);
      this._inputNumber.nativeElement.value = this.nzFormatter(this._value);
    }
  }

  _getBoundValue(value: number): number {
    if (value > this.nzMax) {
      return this.nzMax;
    } else if (value < this.nzMin) {
      return this.nzMin;
    } else {
      return value;
    }
  }

  _isNumber(value: number): boolean {
    return !isNaN(value) && isFinite(value);
  }

  // TODO: normalize value type on @Input
  toPrecisionAsStep(num: number): number {
    const input = num as number | string;
    if (isNaN(num) || input === '') {
      return num;
    }
    return Number(Number(num).toFixed(this._precisionStep));
  }

  constructor(private _elementRef: ElementRef, private _renderer: Renderer2) {
    this._el = this._elementRef.nativeElement;
    this._renderer.addClass(this._el, `${this._prefixCls}`);
  }

  writeValue(value: number): void {
    this._updateValue(value, false);
  }

  registerOnChange(fn: (_: number) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.nzDisabled = isDisabled;
  }

  private _updateValue(value: number, emitChange: boolean = true): void {
    const cacheValue = this._value;
    this._value = this._getBoundValue(value);
    this._displayValue = this.nzFormatter(this._value);
    this._inputNumber.nativeElement.value = this.nzFormatter(this._value);
    if (emitChange && (value !== cacheValue)) {
      this.onChange(this._value);
    }
    this._disabledUp = (this.nzValue !== undefined) && !((this.nzValue + this.nzStep) <= this.nzMax);
    this._disabledDown = (this.nzValue !== undefined) && !((this.nzValue - this.nzStep) >= this.nzMin);
  }
}
